import React from 'react';

/**
 * Loading skeleton components for better UX
 */
export const ProductSkeleton = () => (
  <div className="bg-white rounded-xl p-4 sm:p-6 border-2 border-gray-200 animate-pulse">
    <div className="flex items-start gap-3 sm:gap-4">
      <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-lg bg-gray-200 flex-shrink-0"></div>
      <div className="flex-1 space-y-2">
        <div className="h-4 bg-gray-200 rounded w-3/4"></div>
        <div className="h-3 bg-gray-200 rounded w-full"></div>
        <div className="h-3 bg-gray-200 rounded w-2/3"></div>
      </div>
      <div className="w-16 h-6 bg-gray-200 rounded flex-shrink-0"></div>
    </div>
  </div>
);

export const CardSkeleton = () => (
  <div className="bg-white rounded-xl p-6 border border-gray-200 animate-pulse">
    <div className="h-6 bg-gray-200 rounded w-1/2 mb-4"></div>
    <div className="space-y-3">
      <div className="h-4 bg-gray-200 rounded"></div>
      <div className="h-4 bg-gray-200 rounded w-5/6"></div>
      <div className="h-4 bg-gray-200 rounded w-4/6"></div>
    </div>
  </div>
);

export const TableSkeleton = ({ rows = 5 }) => (
  <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
    <div className="p-4 space-y-3">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex items-center gap-4 animate-pulse">
          <div className="h-4 bg-gray-200 rounded w-1/4"></div>
          <div className="h-4 bg-gray-200 rounded w-1/4"></div>
          <div className="h-4 bg-gray-200 rounded w-1/4"></div>
          <div className="h-4 bg-gray-200 rounded w-1/4"></div>
        </div>
      ))}
    </div>
  </div>
);

export const ButtonSkeleton = () => (
  <div className="h-12 bg-gray-200 rounded-lg animate-pulse w-full"></div>
);

export const FormSkeleton = () => (
  <div className="space-y-4 animate-pulse">
    <div className="h-4 bg-gray-200 rounded w-1/4"></div>
    <div className="h-12 bg-gray-200 rounded-lg"></div>
    <div className="h-4 bg-gray-200 rounded w-1/4"></div>
    <div className="h-12 bg-gray-200 rounded-lg"></div>
    <div className="h-12 bg-gray-200 rounded-lg"></div>
  </div>
);















